import { render } from "./registryAbout.vue?vue&type=template&id=1d624de4&scoped=true"
import script from "./registryAbout.vue?vue&type=script&lang=js"
export * from "./registryAbout.vue?vue&type=script&lang=js"

import "./registryAbout.vue?vue&type=style&index=0&id=1d624de4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d624de4"]])

export default __exports__